module.exports = __webpack_public_path__ + "img/404notfound.5e12cffd.svg";